import { createElementBlock as o, openBlock as t, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 21"
};
function r(a, e) {
  return t(), o("svg", n, [...e[0] || (e[0] = [
    l("path", {
      fill: "currentColor",
      d: "M18.73 7.095q.001.013-.005.025l-1.772 8.115a1.25 1.25 0 0 1-1.228 1.016H4.275a1.25 1.25 0 0 1-1.228-1.016L1.275 7.12q-.002-.012-.005-.025a1.25 1.25 0 0 1 2.168-1.048l2.63 2.835L8.865 2.61v-.007a1.25 1.25 0 0 1 2.27 0v.007l2.797 6.273 2.63-2.835a1.25 1.25 0 0 1 2.166 1.048z"
    }, null, -1)
  ])]);
}
const s = { render: r };
export {
  s as default,
  r as render
};
